// The review queue as this tab last showed it, in memory only (never storage), so coming back from a
// job draws it at once (docs/design/states-pass.md, "show the last thing you knew"). Staff and customer
// names don't outlive the page, and signing out forgets it. Kept apart from Review.tsx so the header
// can forget it without importing the screen.

import type { DonePage, QueuePage } from './review-model.ts';

/** Each list as it was shown, every page "Load more" opened included, with its total. */
type KeptQueue = { queue: QueuePage; back: QueuePage; done: DonePage; at: string };

let kept: { tenant: string; q: KeptQueue } | null = null;
export const rememberedQueue = (tenant: string): KeptQueue | null =>
  kept?.tenant === tenant ? kept.q : null;
export const rememberQueue = (tenant: string, q: KeptQueue): void => {
  kept = { tenant, q };
};
export const forgetQueue = (): void => {
  kept = null;
};
